import moment from "moment";

export const formatMoney = (amount: any) => {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return "";

  // Remove all non-numeric characters
  const cleaned = phoneNumber.replace(/\D/g, "");

  // Format based on length
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 6)
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
    6,
    10
  )}`;
};

export const checkoutDate = (date: Date) => {
  return moment(date).format("ddd, MMM D, YYYY");
};

export const checkoutTime = (date: Date) => {
  return moment(date).format("hh:mmA");
};

export const extractHoursAndMinutes = (
  duration: string | null
): { duration_hours: number; duration_minutes: number } => {
  if (!duration) {
    return { duration_hours: 0, duration_minutes: 0 };
  }

  const parts = duration.split(".");
  const hours = parseInt(parts[0], 10) || 0;
  const decimalPart = parts[1] ? parseInt(parts[1].padEnd(2, "0"), 10) : 0;

  return {
    duration_hours: hours,
    duration_minutes: decimalPart,
  };
};

export const updateEndTime = (
  startTime: Date,
  durationStr: string | number | null | undefined
): Date => {
  const durationAsString =
    durationStr !== undefined && durationStr !== null
      ? durationStr.toString()
      : null;
  const { duration_hours, duration_minutes } =
    extractHoursAndMinutes(durationAsString);

  // Create new end time
  const newEndTime = new Date(startTime);
  newEndTime.setHours(newEndTime.getHours() + duration_hours);
  newEndTime.setMinutes(newEndTime.getMinutes() + duration_minutes);

  return newEndTime;
};

export const formatDurationTime = (
  duration: number | string | undefined
): string => {
  if (!duration) return "";

  const durationStr = duration.toString();

  let hours: number;
  let minutes: number;

  if (durationStr.includes(":")) {
    [hours, minutes] = durationStr.split(":").map(Number);
  } else if (durationStr.includes(".")) {
    [hours, minutes] = durationStr.split(".").map(Number);
  } else {
    hours = Number(durationStr);
    minutes = 0;
  }

  if (!minutes || minutes === 0) {
    return `${hours}`;
  }

  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

export const getFormattedFHDuration = (
  start_at: string,
  end_at: string
): string => {
  if (!start_at || !end_at) return "0 hr";

  const startDate = new Date(start_at);
  const endDate = new Date(end_at);

  const differenceInMilliseconds = endDate.getTime() - startDate.getTime();
  const differenceInHours = differenceInMilliseconds / (60 * 60 * 1000);

  return `${differenceInHours} hr`;
};

export const formatDuration = (
  hours: number | null,
  minutes: number | null
): string | undefined => {
  if (hours === null && minutes === null) return;

  const formattedHours = hours ?? 0;
  const formattedMinutes =
    minutes !== null ? String(minutes).padStart(2, "0") : "";

  return formattedMinutes
    ? `${formattedHours}.${formattedMinutes}`
    : `${formattedHours}`;
};
